import { ComponentProps } from 'react';
import { NavMain } from '@/components/navigation/nav-main';
import { NavUser } from '@/components/navigation/nav-user';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
} from '@/components/ui/sidebar';
import { NavSectionRailButton } from '@/components/navigation/nav-section-rail-button';
import { useNavSections } from '@/components/navigation/use-nav-sections';
import { NotificationBell } from '@/components/notification-center/notification-bell';
import { OrgSwitcher } from '@/components/navigation/org-switcher';

export function AppSidebar({ ...props }: ComponentProps<typeof Sidebar>) {
  const sections = useNavSections();
  const footerSections = sections.filter(
    (section) => section.placement === 'footer',
  );

  return (
    <Sidebar collapsible='icon' {...props}>
      <SidebarHeader className='p-2'>
        <OrgSwitcher />
      </SidebarHeader>
      <SidebarContent className='px-2'>
        <NavMain />
      </SidebarContent>
      <SidebarFooter className='p-2'>
        <SidebarMenu className='gap-2'>
          {footerSections.map((section) => (
            <NavSectionRailButton key={section.id} section={section} />
          ))}
          <NotificationBell />
        </SidebarMenu>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
